import { lazyWithPreload } from '../utils/routePreload';

/**
 * The dashboard's per-look variants, each in its own chunk so a user only
 * downloads the one their shell renders. Kept apart from Dashboard.js so the
 * route warm-up in App.js can fetch the right variant alongside the
 * Dashboard chunk instead of after it.
 */
export const DashboardNew = lazyWithPreload(() => import('./DashboardNew'));
export const DashboardClassic = lazyWithPreload(() => import('./DashboardClassic'));
export const DashboardOverview = lazyWithPreload(() => import('./DashboardOverview'));

/** Warm the variant the current shell (html[data-shell]) will render. */
export const preloadDashboardVariant = () => {
  const inset = typeof document !== 'undefined'
    && document.documentElement.getAttribute('data-shell') === 'inset';
  if (!inset) return DashboardClassic.preload();
  const overview = typeof window !== 'undefined' && window.location.pathname === '/dashboard/overview';
  return overview ? DashboardOverview.preload() : DashboardNew.preload();
};
